/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { NewTermsAndConditions } from '../model';
// @ts-ignore
import { TermsAndConditions } from '../model';
/**
 * TermsAndConditionsApiTermsAndConditionsCountGet - axios parameter creator
 * Retrieve the numver of terms-and-conditions documents
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TermsAndConditionsApiTermsAndConditionsCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/terms-and-conditions/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TermsAndConditionsApiTermsAndConditionsGet - axios parameter creator
 * Find all the terms-and-conditions\'s records
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TermsAndConditionsApiTermsAndConditionsGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/terms-and-conditions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TermsAndConditionsApiTermsAndConditionsIdDelete - axios parameter creator
 * Delete a single terms-and-conditions record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TermsAndConditionsApiTermsAndConditionsIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('termsAndConditionsIdDelete', 'id', id)
    const localVarPath = `/terms-and-conditions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TermsAndConditionsApiTermsAndConditionsIdGet - axios parameter creator
 * Find one terms-and-conditions record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TermsAndConditionsApiTermsAndConditionsIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('termsAndConditionsIdGet', 'id', id)
    const localVarPath = `/terms-and-conditions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TermsAndConditionsApiTermsAndConditionsIdPut - axios parameter creator
 * Update a single terms-and-conditions record
 * @summary 
 * @param {string} id 
 * @param {NewTermsAndConditions} newTermsAndConditions 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TermsAndConditionsApiTermsAndConditionsIdPutAxiosParamCreator (id: string, newTermsAndConditions: NewTermsAndConditions, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('termsAndConditionsIdPut', 'id', id)
    // verify required parameter 'newTermsAndConditions' is not null or undefined
    assertParamExists('termsAndConditionsIdPut', 'newTermsAndConditions', newTermsAndConditions)
    const localVarPath = `/terms-and-conditions/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newTermsAndConditions, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TermsAndConditionsApiTermsAndConditionsPost - axios parameter creator
 * Create a new terms-and-conditions record
 * @summary 
 * @param {NewTermsAndConditions} newTermsAndConditions 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TermsAndConditionsApiTermsAndConditionsPostAxiosParamCreator (newTermsAndConditions: NewTermsAndConditions, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newTermsAndConditions' is not null or undefined
    assertParamExists('termsAndConditionsPost', 'newTermsAndConditions', newTermsAndConditions)
    const localVarPath = `/terms-and-conditions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newTermsAndConditions, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for termsAndConditionsGet operation in TermsAndConditionsApi.
 * @export
 * @interface TermsAndConditionsApiTermsAndConditionsGetRequest
 */
export interface TermsAndConditionsApiTermsAndConditionsGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof TermsAndConditionsApiTermsAndConditionsGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof TermsAndConditionsApiTermsAndConditionsGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof TermsAndConditionsApiTermsAndConditionsGet
     */
    readonly start?: number
}

/**
 * Request parameters for termsAndConditionsIdDelete operation in TermsAndConditionsApi.
 * @export
 * @interface TermsAndConditionsApiTermsAndConditionsIdDeleteRequest
 */
export interface TermsAndConditionsApiTermsAndConditionsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof TermsAndConditionsApiTermsAndConditionsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for termsAndConditionsIdGet operation in TermsAndConditionsApi.
 * @export
 * @interface TermsAndConditionsApiTermsAndConditionsIdGetRequest
 */
export interface TermsAndConditionsApiTermsAndConditionsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TermsAndConditionsApiTermsAndConditionsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for termsAndConditionsIdPut operation in TermsAndConditionsApi.
 * @export
 * @interface TermsAndConditionsApiTermsAndConditionsIdPutRequest
 */
export interface TermsAndConditionsApiTermsAndConditionsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof TermsAndConditionsApiTermsAndConditionsIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewTermsAndConditions}
     * @memberof TermsAndConditionsApiTermsAndConditionsIdPut
     */
    readonly newTermsAndConditions: NewTermsAndConditions
}

/**
 * Request parameters for termsAndConditionsPost operation in TermsAndConditionsApi.
 * @export
 * @interface TermsAndConditionsApiTermsAndConditionsPostRequest
 */
export interface TermsAndConditionsApiTermsAndConditionsPostRequest {
    /**
     * 
     * @type {NewTermsAndConditions}
     * @memberof TermsAndConditionsApiTermsAndConditionsPost
     */
    readonly newTermsAndConditions: NewTermsAndConditions
}

/**
* Retrieve the numver of terms-and-conditions documents
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TermsAndConditionsApiTermsAndConditionsCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TermsAndConditionsApiTermsAndConditionsCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Find all the terms-and-conditions\'s records
* @summary 
* @param {TermsAndConditionsApiTermsAndConditionsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TermsAndConditionsApiTermsAndConditionsGet(requestParameters: TermsAndConditionsApiTermsAndConditionsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TermsAndConditionsApiTermsAndConditionsGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<Array<TermsAndConditions>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a single terms-and-conditions record
* @summary 
* @param {TermsAndConditionsApiTermsAndConditionsIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TermsAndConditionsApiTermsAndConditionsIdDelete(requestParameters: TermsAndConditionsApiTermsAndConditionsIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TermsAndConditionsApiTermsAndConditionsIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Find one terms-and-conditions record
* @summary 
* @param {TermsAndConditionsApiTermsAndConditionsIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TermsAndConditionsApiTermsAndConditionsIdGet(requestParameters: TermsAndConditionsApiTermsAndConditionsIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TermsAndConditionsApiTermsAndConditionsIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<TermsAndConditions> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a single terms-and-conditions record
* @summary 
* @param {TermsAndConditionsApiTermsAndConditionsIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TermsAndConditionsApiTermsAndConditionsIdPut(requestParameters: TermsAndConditionsApiTermsAndConditionsIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TermsAndConditionsApiTermsAndConditionsIdPutAxiosParamCreator(requestParameters.id, requestParameters.newTermsAndConditions, options, configuration);
    const request: () => AxiosPromise<TermsAndConditions> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new terms-and-conditions record
* @summary 
* @param {TermsAndConditionsApiTermsAndConditionsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TermsAndConditionsApiTermsAndConditionsPost(requestParameters: TermsAndConditionsApiTermsAndConditionsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TermsAndConditionsApiTermsAndConditionsPostAxiosParamCreator(requestParameters.newTermsAndConditions, options, configuration);
    const request: () => AxiosPromise<TermsAndConditions> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
